import React from 'react';
import { Link } from 'react-router-dom';

const ServicesOneHiringAreaSurgicalOncology = () => {
    return (
        <>
            <section className="hiring-area pt-120 pb-120">
                <div className="container">
                    <div className="row no-gutters hire-bg-2">
                        <div className="col-xl-6 col-lg-6">
                            <div className="hire-img">
                                <img className="img" src="img/doctor/Dr. Sudhendu Shekhar.jpg" alt="" />
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-6">
                            <div className="hire-text">
                                <h1>Dr. SUDHENDU SHEKHAR</h1>
                                <p>
                                    Surgical Oncologist | MBBS, MS Fellow HPB Fellowship Surgical Oncology, TMH Mumbai
                                    <br />
                                    Fellowship in Surgical Gastroenterology, Liver, Billiary & Pancreatic Surgery, Sir Ganga Ram Hospital, New Delhi.
                                    <br />
                                    Ex. Asst. Prof. Surgical Oncology MPMMCC/HBCH, TMC Varanasi Ex. Senior Consultant Surgical Oncology
                                    <br />
                                    Indian Railway Cancer Institute, Varanasi.
                                    <br />
                                    14 years Experience | Over 5000 Cancer Surgeries.
                                </p>
                                <Link to="/contact"
                                    className="primary_btn btn-icon btn-icon-green ml-0"><span>+</span>Contact us</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default ServicesOneHiringAreaSurgicalOncology;